<template>
  <div v-if="isLoggedIn">
    <!-- Redirection gérée par le router -->
  </div>
  <div v-else data-component="Login" class="flex">
    <section class="flex-1 text-center" data-is="left-panel">
      <div class="text-center">
        <header>
          <div class="logo w-full">
            <img :src="logoSrc" alt="PrimView, by scaprim" />
          </div>
        </header>
        <form @submit="handleSubmit">
          <div class="mb-4">
            <input 
              type="text" 
              @input="onUsernameChange" 
              @focus="onResetTooltip" 
              :class="{ 'border-pink': usernameError }" 
              name="username" 
              id="username" 
              :value="username"
            />
            <label for="username">Utilisateur <small>(prenom.nom)</small></label>
            <p v-if="usernameError" class="text-pink">{{ usernameError }}</p>
          </div>
          <div class="mb-4">
            <input 
              @input="onPasswordChange" 
              @focus="onResetTooltip" 
              :class="{ 'border-pink': passwordError }" 
              name="password" 
              type="password" 
              :value="password" 
              id="password"
            />
            <label for="password">Mot de passe</label>
          </div>
          <p v-if="passwordError" class="text-pink">{{ passwordError }}</p>
          <button
            :disabled="isSubmitDisabled || loading"
            type="submit"
            data-component="Widget/Button"
            class="btn-xs uppercase"
          >
            <div v-if="loading" class="spinner"></div>
            <span :class="{ 'opacity-0': loading }">
              Me connecter
            </span>
          </button>
          <div class="tooltip-container">
            <!-- Help Tooltip -->
            <div v-if="tooltip" class="tooltip" @click="onClickTooltip">
              <div class="closeDiv"><i class="ico close"/></div>
              <div class="tooltipcontent">
                <p><span>Utilisateur :</span> Il s'agit du nom d'utilisateur que vous utilisez lors de votre connexion à votre ordinateur Windows. Il est de la forme "prenom.nom".</p>
                <br/>
                <p><span>Mot de passe :</span> Il s'agit du nom d'utilisateur que vous utilisez lors de votre connexion à votre ordinateur Windows, vous seul le connaissez</p>
              </div>
            </div>
            <!-- Issue Tooltip -->
            <p v-else><a href="/" @click.prevent="onClickTooltip">Un problème de connexion ?</a></p>
          </div>
          <div id="keyboard-margin" :class="{ hidden: !isKeyboardMarginShowing }"></div>
        </form>
      </div>
    </section>

    <section class="flex-1" data-is="right-panel">
      <img :src="backgroundSrc" alt="PrimView - Connexion à votre compte" />
    </section>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import logoSrc from '../assets/images/Logo.png'
import backgroundSrc from '../assets/images/login/Background.jpg'

export default {
  name: 'LoginView',
  data() {
    return {
      logoSrc,
      backgroundSrc
    }
  },
  computed: {
    ...mapState('login', [
      'username',
      'password',
      'tooltip',
      'usernameError', 
      'passwordError',
      'loading',
      'isLoggedIn',
      'isHeightExtended'
    ]),
    ...mapGetters('login', [
      'isSubmitDisabled'
    ]),
    referer() {
      return this.$route.query.from ? decodeURIComponent(this.$route.query.from) : '/visites'
    },
    isKeyboardMarginShowing() {
      return this.isHeightExtended
    }
  },
  mounted() {
    this.enterLogin()
    
    // S'assurer que le paramètre "from" est toujours présent dans l'URL (avec "/" par défaut)
    if (!Object.prototype.hasOwnProperty.call(this.$route.query, 'from')) {
      this.$router.replace({
        name: this.$route.name,
        query: { ...this.$route.query, from: '/' }
      })
    }
    
    // Redirection immédiate si déjà connecté (comme dans le composant React)
    if (this.isLoggedIn) {
      this.$router.push(this.referer)
    }
  },
  watch: {
    isLoggedIn(newVal) {
      if (newVal) {
        this.$router.push(this.referer)
      }
    }
  },
  methods: {
    ...mapActions('login', [
      'changeUsername',
      'changePassword',
      'toggleTooltip',
      'resetTooltip',
      'sendCredentials',
      'enterLogin'
    ]),
    handleSubmit(event) {
      event.preventDefault()
      this.sendCredentials()
    },
    onUsernameChange(event) {
      this.changeUsername(event.target.value)
    },
    onPasswordChange(event) {
      this.changePassword(event.target.value)
    },
    onClickTooltip(event) {
      event.preventDefault()
      this.toggleTooltip()
    },
    onResetTooltip() {
      this.resetTooltip()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './Login.scss';
</style>
